import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import CaregiverSignUpStepper from '../components/CaregiverSignUpStepper';

// FEAT-045 — Caregiver Sign-Up Stepper page (web).
// MVP-8.10, MVP-8.11, MVP-18.17. Mounted at /caregiver-sign-up — see
// AppNavigator. The page is a thin wrapper around the stepper so the
// route surface stays minimal and the stepper itself owns its own
// progress + validation lifecycle.

const CaregiverSignUpPage: React.FC = () => {
  const navigate = useNavigate();

  const handleExit = () => {
    navigate('/caregiver-profile-management');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }} data-testid="caregiver-sign-up-page">
      <CaregiverSignUpStepper onExit={handleExit} />
    </Container>
  );
};

export default CaregiverSignUpPage;
